import request from '../../utils/request'
import { judgePermissions } from '@/utils/common.js'

const state = {}

const actions = {
    // 获取成绩管理列表
    getAchievementList({ dispatch }, data) {
        return new Promise((resolve)=>{
            judgePermissions(['review:plan:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/review/plan`,
                        method: 'get',
                        params: data
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve({data:null})
                }
            })
        })
    },
    // 考试计划下拉框
    // getArrangementExamPlan({dispatch}, data) {
    //     return new Promise((resolve)=>{
    //         request({
    //             url: `/api/arrangement/exam/plan/end`,
    //         }).then((data)=>{
    //             resolve(data);
    //         })
    //     })
    // },

    // 创建批阅计划
    postReviewPlan({dispatch}, data) {
        return new Promise((resolve)=>{
            request({
                url: `/api/review/plan`,
                method: 'post',
                data
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 编辑批阅计划
    putReviewPlan({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/review/plan`,
                method: 'put',
                data
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 查询批阅计划详情
    getReviewPlanDetail({dispatch},id){
        return new Promise((resolve)=>{
            request({
                url: `/api/review/plan/com.tipdm:tipdm-race-web:jar:v1.10.0`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 编辑批阅计划-获取所有评阅老师
    getAllReviewer({dispatch}){
        return new Promise((resolve)=>{
            request({
                url: `/api/user/all`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 重批弹窗：查询批阅人
    getReviewer({dispatch}, data){
        return new Promise((resolve)=>{
            request({
                url: `/api/review/reviewer/${data}`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 重批
    putReviewAgain({dispatch}, data){
        return new Promise((resolve)=>{
            request({
                url: `/api/review/status`,
                method: "put",
                data: {
                    reviewIdList: data
                }
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 特殊处理/撤销处理
    putSpecialTreatment({dispatch}, data){
        return new Promise((resolve)=>{
            request({
                url: `/api/arrangement/examinee/exam_status/${data.examineeId}/${data.examStatus}`,
                method: "put",
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 查看成绩列表
    getExamineeScoreList({ dispatch }, data) {
        return new Promise((resolve)=>{
            judgePermissions(['review:result:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/review/result`,
                        method: 'get',
                        params: data
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve({data:null})
                }
            })
        })
    },

    // 导出弹窗-批阅统计概况
    getReviewData({dispatch}, param){
        return new Promise((resolve)=>{
            request({
                url: `/api/review/survey/${param.examId}/${param.examPaperId}`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 导出弹窗
    getExportScore({dispatch}, param){
        return new Promise((resolve)=>{
            request({
                url: `/api/review/plan/export_score/${param.examId}/${param.examPaperId}`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 导出弹窗-生成详细成绩单
    getDetailScore({dispatch}, param){
        return new Promise((resolve)=>{
            request({
                url: `/api/review/plan/${param.examId}/${param.examPaperId}/detail_score/downloads`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },
}

export default {
    state,
    actions
}